import React from 'react';
import { Routes, Route } from "react-router-dom";
import HomeContent from '../pages/home';
import LoginPage from '../pages/auth/Login';
import NotFoundPage from '../pages/404/NotFoundPage';
import PrivateRoutes from './PrivateRoutes';
import PublicRoute from './PublicRoute';

import '../styles/globals.css';
import CambiarPasswordPage from '../pages/auth/CambiarPassword';
import PaisesPage from '../pages/pais';
import CiudadPage from '../pages/ciudad';
import ClientePage from '../pages/cliente';
import ServiciosPage from '../pages/servicios'
import {FacturaVentaPage, FacturaPdfPage} from '../pages/factura';
import ConfiguracionesPage from '../pages/configuraciones';
import PersonaPage from '../pages/persona';
import RolPage from '../pages/rol';
import PermisoPage from '../pages/permiso';
import UsuarioPage from '../pages/usuario';
import {PresupuestoPage, PresupuestoPdfPage }from '../pages/presupuesto';

export default function AppRouter() {

    return (
        <Routes>
            <Route element={<PrivateRoutes />} >
                <Route path="/" element={<HomeContent />} />    
                <Route path='/pais' element={<PaisesPage />} />
                <Route path='/ciudad' element={<CiudadPage />} />
                <Route path='/cliente' element={<ClientePage />} />
                <Route path='/servicios' element={<ServiciosPage />} />
                <Route path='/factura_venta' element={<FacturaVentaPage />} />
                <Route path='/factura_venta/pdf/:id' element={<FacturaPdfPage />} />
                <Route path='/persona' element={<PersonaPage />} />
                <Route path='/rol' element={<RolPage />} />
                <Route path='/permiso' element={<PermisoPage />} />
                <Route path='/configuraciones' element={<ConfiguracionesPage />} />
                <Route path='/usuario' element={<UsuarioPage />} />
                <Route path="/cambiar-password" element={<CambiarPasswordPage />} />
                <Route path="/presupuesto" element={<PresupuestoPage />} />
                <Route path='/presupuesto/pdf/:id' element={<PresupuestoPdfPage />} />
   
            </Route>

            <Route element={<PublicRoute />}>
                <Route path="/login" element={<LoginPage />} />
                
            </Route>
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    );
}